import React from "react";
import accountIcon from "../assets/images/account.png";
import notificationIcon from "../assets/images/notification.png";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLanguage } from "@fortawesome/free-solid-svg-icons";
import { hasAdminToken } from "../auth/adminSession";

const TopItems = ({
  showLanguageToggle = false,
  language = "en",
  onToggleLanguage,
  showMenuToggle = false,
  menuOpen = false,
  onToggleMenu,
  menuToggleRef,
  direction = "ltr"
}) => {
  const nextLanguage = language === "en" ? "AR" : "EN";
  const label =
    language === "en" ? "Switch page content to Arabic" : "Switch page content to English";
  const menuLabel = language === "ar"
    ? menuOpen ? "إغلاق قائمة التنقل" : "فتح قائمة التنقل"
    : menuOpen ? "Close navigation menu" : "Open navigation menu";

  return (
    <>
      {hasAdminToken() && (
        <header
          className="admin-shell-header"
          dir={direction}
        >
          {showMenuToggle && (
            <button
              ref={menuToggleRef}
              type="button"
              className="admin-mobile-menu-toggle"
              onClick={onToggleMenu}
              aria-label={menuLabel}
              aria-controls="admin-mobile-navigation"
              aria-expanded={menuOpen}
            >
              <i
                className={`fa-solid ${menuOpen ? "fa-xmark" : "fa-bars"}`}
                aria-hidden="true"
              />
            </button>
          )}
          {showLanguageToggle && (
            <button
              type="button"
              className="admin-language-toggle"
              onClick={onToggleLanguage}
              title={label}
              aria-label={label}
            >
              <FontAwesomeIcon icon={faLanguage} />
              <span>{nextLanguage}</span>
            </button>
          )}
          <Link to={"/changepasssword"} className="admin-shell-action">
            <img
              src={accountIcon}
              alt="accountIcon"
            />
          </Link>
          <Link to={"/notificationscenter"} className="admin-shell-action">
            <img
              src={notificationIcon}
              alt="notificationIcon"
            />
          </Link>
        </header>
      )}
    </>
  );
};

export default TopItems;
